export default __webpack_public_path__ + "static/media/delivery-assigned-icon.c8de41e0.svg";